<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-4">
        At
        <stemble-latex :content="'$37^o\\text{C},$'" />
        <number-value :value="molAB3" unit="\text{mol}" />
        of the salt
        <chemical-latex content="AB3" />
        is soluble in
        <stemble-latex :content="'$0.500\\text{ L}$'" />
        of water. Determine the value of
        <stemble-latex :content="'$K_{\\text{sp}}$'" />
        for the salt at this temperature.
      </p>

      <calculation-input
        v-model="inputs.Ksp"
        :prepend-text="'$\\text{K}_{\\mathrm{sp}}$'"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ChemicalLatex from '../displayers/ChemicalLatex';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question125',
  components: {
    StembleLatex,
    ChemicalLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        Ksp: null,
      },
    };
  },
  computed: {
    molAB3() {
      return this.taskState.getValueBySymbol('molAB3').content;
    },
  },
};
</script>
